module.exports = __webpack_public_path__ + "static/media/HRApprova_User_Manual.0df89990.pdf";